if (typeof NodeList.prototype.forEach === "undefined") {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

if (typeof HTMLCollection.prototype.forEach === "undefined") {
	HTMLCollection.prototype.forEach = Array.prototype.forEach;
}


String.prototype.hashCode = function () {
	var hash = 0, i, chr, len;
	if (this.length == 0) return hash;
	for (i = 0, len = this.length; i < len; i++) {
		chr  = this.charCodeAt(i);
		hash = ((hash << 5) - hash) + chr;
		hash |= 0; // Convert to 32bit integer
	}
	return hash;
};

VLW.utils = VLW.utils || {};

(function(){
    var functionLogger = {};

    functionLogger.log = true;//Set this to false to disable logging

    /**
     * Gets a function that when called will log information about itself if logging is turned on.
     *
     * @param func The function to add logging to.
     * @param name The name of the function.
     *
     * @return A function that will perform logging and then call the function.
     */
    functionLogger.getLoggableFunction = function(func, name, tag) {
        return function() {
            if (functionLogger.log) {
                var logText = '';
                if(tag){
                    logText += tag + ' ';
                }
                logText += name + '(';

                for (var i = 0; i < arguments.length; i++) {
                    if (i > 0) {
                        logText += ', ';
                    }
                    logText += arguments[i];
                }
                logText += ');';

                console.log(logText);
            }

            return func.apply(this, arguments);
        }
    };

    /**
     * After this is called, all direct children of the provided namespace object that are
     * functions will log their name as well as the values of the parameters passed in.
     *
     * @param namespaceObject The object whose child functions you'd like to add logging to.
     */
    functionLogger.addLoggingToNamespace = function(namespaceObject, tag, ignores = []){
        for(var name in namespaceObject){
            if(ignores.indexOf(name) !== -1){
                continue;
            }
            var potentialFunction = namespaceObject[name];

            if(Object.prototype.toString.call(potentialFunction) === '[object Function]'){
                namespaceObject[name] = functionLogger.getLoggableFunction(potentialFunction, name, tag);
            }
        }
    };
    VLW.utils.functionLogger = functionLogger;
})();